import React, { Component } from 'react'
import ProtectedRoute from './ProtectedRoute';
import { routes } from './routes';
import Dashboard from './template/Dashboard';

export default class routesNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      routes: [],
    };
  }
  componentDidMount() {
    const r = routes;
    const found = [];
    const child = [];
    const mod = JSON.parse(localStorage.getItem('menu'));
    if (mod !== null) {
      const x = mod.sort(function (a, b) {
        return a.sort - b.sort;
      });
      x.map((data, key) => {
        if (data.parent_id === null) {
          if (r.find((element) => element.name === data.name) !== undefined){
            found.push(r.find((element) => element.name === data.name));
          }
        }
      });
    }
    this.setState({ routes: found });
  }

  render() {
    return (
      <div>
        {this.state.routes.map((prop, key) => {
          if (!prop.child) {
            return (
              <ProtectedRoute
                path={prop.path}
                child={prop.component}
                component={Dashboard}
                key={key}
              />
            )
          }
          else {
            return prop.child.map((child, ky) => {
              return (
                <ProtectedRoute
                  path={child.path}
                  child={child.component}
                  component={Dashboard}
                  key={ky}

                />
              )
            })
          };
        })}
        {/* <Route render={ () => <h1>404 not found</h1> } /> */}
      </div>
    )
  }
}
